<div class="modal" (click)="stopPropagation($event)">
    <div class="modal-content" (click)="stopPropagation($event)">
        <div class="modal-header"> {{ header }} </div>
        <div class="modal-body">
            <div class="msg-wrapper">{{ msg }}</div>
            <div class="list-wrapper">
                <div class="list" *ngFor="let item of list">{{ item }}</div>
            </div>
            <mat-progress-bar mode="determinate" [value]="progress" [color]="progressColor"></mat-progress-bar>
            <div class="text-count">{{ count }} / {{ total }} {{ unit }}</div>

            <div class="msg-wrapper" *ngIf="otherInfosMode">
              <mat-card class="otherInfosCard">
                <div>{{ otherInfosModeMessage }}</div>
              </mat-card>
            </div>

            <div class="error" *ngIf="errorMode">
              <mat-card class="errorCard">
                <div class="iconCard"><object class="button" type="image/svg+xml" data="/assets/icons-white/alert-triangle.svg"></object></div>
                <div>{{ errorModeMessage }}</div>
              </mat-card>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>
